import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "inventory-pick" }

import Loading from '@/components/Loading.vue';
import PicklistDetail from '@/components/Picklist/PicklistDetail.vue';
import pinia from '@/plugins/pinia';
import {doConfirm} from '@/util';
import {ApiPicklistState} from '@/model/Picklist';
import {onBeforeRouteLeave} from 'vue-router';
import {useApplicationState} from '@/store/applicationState';
import useDetailPicklistStore from '@/store/detailPicklist';
import {usePicklistPickerStore} from '@/store/picklistPickerV2';
import {useStorageRaw} from '@/composables/storage';
import Error from '@/components/Error.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CorrectionsPick',
  setup(__props, { expose: __expose }) {

const applicationState = useApplicationState(pinia);
const picklistPicker = usePicklistPickerStore(pinia);
const store = useDetailPicklistStore();
applicationState.updateTitle(store.data?.Picklistnr ? `Bestandskorrektur ${store.data?.Picklistnr}` : 'Neue Bestandskorrektur');
useStorageRaw(
    store,
    (picklist) => picklist?.Picklistnr > 0 ? `Bestandskorrektur ${picklist?.Picklistnr}` : 'Neue Bestandskorrektur',
    null,
    () => {
      picklistPicker.edit().catch(console.error);
    },
);

onBeforeRouteLeave(async (_to, _from, next) => {
  if (picklistPicker.picklist?.Status === ApiPicklistState.Active) {
    if (await doConfirm('Soll die Anlage der Bestandskorrektur wirklich abgebrochen werden?', 'Wirklich abbrechen?')) {
      await picklistPicker.cancel();
    } else {
      next(false);
      return;
    }
  }
  next();
});


__expose({
  Loading,
  PicklistDetail,
  picklistPicker,
  store,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(store).error && !_unref(store).loading && _unref(store).data)
      ? (_openBlock(), _createBlock(PicklistDetail, {
          key: 0,
          data: _unref(store).data,
          "can-add": "",
          "can-delete": "",
          modelValue: _unref(picklistPicker).selectedPosition,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(picklistPicker).selectedPosition) = $event))
        }, null, 8, ["data", "modelValue"]))
      : _createCommentVNode("", true),
    (_unref(store).error)
      ? (_openBlock(), _createBlock(Error, {
          key: 1,
          module: _unref(store).$id
        }, null, 8, ["module"]))
      : _createCommentVNode("", true),
    (_unref(store).loading)
      ? (_openBlock(), _createBlock(Loading, { key: 2 }))
      : _createCommentVNode("", true)
  ]))
}
}

})